/* ===================== HIGHWAN — theme behaviour ===================== */
(function () {
  // header scroll state
  var sh = document.getElementById('siteHeader');
  var onScroll = function () {
    if (!sh) return;
    if (window.scrollY > 20) sh.classList.add('scrolled');
    else sh.classList.remove('scrolled');
  };
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  // mobile menu
  var burger = document.getElementById('burger');
  var menu = document.getElementById('mobileMenu');
  if (burger && menu) {
    burger.addEventListener('click', function () { menu.classList.toggle('open'); });
    menu.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () { menu.classList.remove('open'); });
    });
  }

  // header products dropdown
  document.querySelectorAll('[data-nav-dropdown]').forEach(function (dropdown) {
    var toggle = dropdown.querySelector('[data-nav-dropdown-toggle]');
    if (!toggle) return;
    toggle.addEventListener('click', function (e) {
      e.stopPropagation();
      var open = dropdown.classList.toggle('open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });
  document.addEventListener('click', function (e) {
    document.querySelectorAll('[data-nav-dropdown].open').forEach(function (dropdown) {
      if (!dropdown.contains(e.target)) {
        dropdown.classList.remove('open');
        var toggle = dropdown.querySelector('[data-nav-dropdown-toggle]');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
      }
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('[data-nav-dropdown].open').forEach(function (dropdown) {
        dropdown.classList.remove('open');
      });
    }
  });

  // FAQ accordion
  document.querySelectorAll('.faq-q').forEach(function (q) {
    q.addEventListener('click', function () {
      var item = q.closest('.faq-item');
      var a = item.querySelector('.faq-a');
      var open = item.classList.toggle('open');
      a.style.maxHeight = open ? a.scrollHeight + 'px' : '0';
    });
  });

  // hash anchor scroll (robust gegen spät ladendes Layout/Videos)
  var scrollToHash = function (smooth) {
    if (!location.hash) return;
    var el = document.getElementById(location.hash.slice(1));
    if (!el) return;
    var y = el.getBoundingClientRect().top + window.scrollY - 90;
    window.scrollTo({ top: y, behavior: smooth ? 'smooth' : 'auto' });
  };
  if (location.hash) {
    setTimeout(function () { scrollToHash(true); }, 250);
    window.addEventListener('load', function () {
      setTimeout(function () { scrollToHash(false); }, 300);
      setTimeout(function () { scrollToHash(false); }, 1200);
    });
  }
  window.addEventListener('hashchange', function () { scrollToHash(true); });

  // product gallery thumbnails
  document.querySelectorAll('.gallery-thumbs').forEach(function (thumbs) {
    var gallery = thumbs.closest('.gallery');
    var main = gallery && gallery.querySelector('.gallery-main');
    if (!main) return;
    thumbs.querySelectorAll('.thumb').forEach(function (btn) {
      btn.addEventListener('click', function () {
        thumbs.querySelectorAll('.thumb').forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
        var idx = btn.dataset.galleryThumb;
        main.querySelectorAll('.gallery-main-img').forEach(function (img) {
          img.classList.toggle('active', img.dataset.galleryImg === idx);
        });
      });
    });
  });

  // product variant picker (color/size etc.)
  document.querySelectorAll('.variant-picker').forEach(function (picker) {
    var detail = picker.closest('.detail');
    if (!detail) return;
    var priceEl = detail.querySelector('[data-product-price]');
    var stockEl = detail.querySelector('[data-stock-value]');
    var variantInput = detail.querySelector('[data-variant-input]');
    var addBtn = detail.querySelector('[data-add-to-cart-btn]');
    var btnLabel = detail.querySelector('[data-btn-label]');
    var allInputs = picker.querySelectorAll('[data-variant-picker-input]');
    var defaultVideo = detail.querySelector('[data-variant-video-default]');
    var variantVideos = detail.querySelectorAll('[data-variant-video]');

    var paintSwatches = function () {
      allInputs.forEach(function (input) {
        var label = input.nextElementSibling;
        if (!label) return;
        var swatch = label.style.getPropertyValue('--swatch');
        if (input.checked) {
          label.style.borderColor = swatch || 'var(--gold)';
          label.style.color = swatch || 'var(--gold)';
        } else {
          label.style.borderColor = '';
          label.style.color = '';
        }
      });
    };
    paintSwatches();

    // variantenabhängiges Video (z. B. Gold/Silber beim Feuerzeugband)
    var syncVariantVideo = function (input) {
      if (!variantVideos.length) return;
      var title = input.dataset.variantTitle || '';
      var matched = false;
      variantVideos.forEach(function (vid) {
        var show = vid.dataset.variantVideo && title.indexOf(vid.dataset.variantVideo) !== -1;
        vid.style.display = show ? '' : 'none';
        if (show) {
          matched = true;
          if (vid.play) {
            var p = vid.play();
            if (p && p.catch) p.catch(function () {});
          }
        }
      });
      if (defaultVideo) defaultVideo.style.display = matched ? 'none' : '';
    };
    var checkedInput = picker.querySelector('[data-variant-picker-input]:checked');
    if (checkedInput) syncVariantVideo(checkedInput);

    allInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        if (!input.checked) return;
        paintSwatches();
        syncVariantVideo(input);

        var price = input.dataset.price;
        var available = input.dataset.available === 'true';
        var inventory = input.dataset.inventory;

        if (priceEl) priceEl.textContent = price;
        if (variantInput) variantInput.value = input.dataset.variantId;

        if (stockEl) {
          var editionTotal = parseInt(stockEl.dataset.editionTotal || '0', 10);
          stockEl.textContent = editionTotal > 0
            ? inventory + ' / ' + editionTotal
            : inventory + ' verfügbar';
        }

        if (addBtn) {
          addBtn.disabled = !available;
          addBtn.classList.toggle('soldout', !available);
        }
        if (btnLabel) {
          btnLabel.textContent = available ? ('In den Warenkorb — ' + price) : 'Ausverkauft';
        }
      });
    });
  });

  // quantity steppers
  document.querySelectorAll('.qty').forEach(function (qty) {
    var input = qty.querySelector('input');
    qty.querySelectorAll('button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = parseInt(input.step || '1', 10);
        var min = parseInt(input.min || '1', 10);
        var val = parseInt(input.value || '1', 10);
        val = btn.dataset.dir === 'up' ? val + step : Math.max(min, val - step);
        input.value = val;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });
})();
